"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityNamespaceIterable = exports.ReportTypeIterable = void 0;
const DbTables_1 = require("../DbTables");
exports.ReportTypeIterable = [
    'borrowerSubmittedServicerReport',
    'extendedResponseTape',
    'newlyAssignedExtendedResponseTape',
    'rawAssignedLoanTape',
    'responseTape',
    'servicerReport',
    ...DbTables_1.AssignedLoanTapeReportTypeIterable,
    ...DbTables_1.BorrowingBaseServicerReportTypeIterable,
    ...DbTables_1.ComplianceReportCfTypeIterable,
    ...DbTables_1.CreditFacilityReportTypeIterable,
    ...DbTables_1.FundingRequestReportTypeIterable,
    ...DbTables_1.InvoiceReportTypeIterable,
    ...DbTables_1.LenderShareReportTypeIterable,
    ...DbTables_1.ReceivableResponseTapePreviewReportTypeIterable,
    ...DbTables_1.BatchSettlementReportTypeIterable,
];
exports.EntityNamespaceIterable = [
    'assigned_loan_tapes',
    'borrowing_base_reports',
    'credit_facility_lender_shares',
    'funding_requests',
    'invoices',
    'invoice_payment_in_kind_items',
    'receivable_response_tape_previews',
    'credit_facility_batch_settlements',
];
//# sourceMappingURL=ReportV2.js.map